import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { ReactComponent as FlagSVG } from "assets/images/flag.svg";
import { ReactComponent as DeleteSVG } from "assets/images/delete-outline.svg";
import { useClearChatMutation } from "store/current-user/current-user.api";

export const ChatMenu: FC = () => {
  const { chatMenu } = useShallowPickSelector("app", ["chatMenu"]);
  const { user, auth } = useShallowPickSelector("currentUser", [
    "user",
    "auth",
  ]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const [clearChat] = useClearChatMutation();

  const onClose = () => {
    dispatch(
      appActions.setChatMenu({ isOpen: false, userId: null, chatId: null })
    );
  };

  const onClickReport: MouseEventHandler = () => {
    if (chatMenu.userId) {
      dispatch(
        appActions.setReportUserMenu({ isOpen: true, userId: chatMenu.userId })
      );
      onClose();
    }
  };

  const onClickDeleteChat: MouseEventHandler = () => {
    if (chatMenu.chatId) {
      clearChat({ chatId: chatMenu.chatId });
      onClose();
      navigate(-1);
    }
  };

  return (
    <BottomSheet
      title={"گزینه‌ها"}
      isOpen={chatMenu.isOpen}
      onClose={onClose}
      items={[
        { text: "گزارش کاربر", icon: <FlagSVG />, onClick: onClickReport },
        {
          text: "حذف چت",
          icon: <DeleteSVG />,
          onClick: onClickDeleteChat,
        },
      ]}
    />
  );
};
